import React from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { bugsnagConfig } from './lib/currentApplication'

const { api_key: apiKey, release_stage: releaseStage, enabled } = bugsnagConfig

let ErrorBoundary = ({ children }) => children

if (apiKey && enabled) {
  Bugsnag.start({
    apiKey,
    plugins: [new BugsnagPluginReact()],
    releaseStage,
    enabledReleaseStages: ['production', 'staging']
  })

  ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)
}

export { ErrorBoundary }
export default Bugsnag
